import { render, staticRenderFns } from "./BattleReport.vue?vue&type=template&id=594581b6&scoped=true&"
import script from "./BattleReport.vue?vue&type=script&lang=js&"
export * from "./BattleReport.vue?vue&type=script&lang=js&"
import style0 from "./BattleReport.vue?vue&type=style&index=0&id=594581b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594581b6",
  null
  
)

export default component.exports